import React, { FC } from "react";
import { BorderedCard } from "@/common/components/BorderedCard/bordered-card";
import { SummaryRows } from "@/common/components/SummaryRows/summary-rows";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import type { SummaryRow } from "@/pages/OrderTracking/order-tracking.types";

export interface OrderSummaryPanelProps {
  orderNumber: string;
  rows: SummaryRow[];
}

export const OrderSummaryPanel: FC<OrderSummaryPanelProps> = ({ orderNumber, rows }) => {
  const panelRows: SummaryRow[] = [
    { label: getString("orderTracking.summary.orderNumberLabel"), value: orderNumber },
    ...rows.map((row, index) => (index === 0 ? { ...row, hasDividerAbove: true } : row)),
  ];

  return (
    <BorderedCard borderRadius="300" padding={["S300", "S400"]} dataTestId="order-summary-panel">
      <SummaryRows rows={panelRows} />
    </BorderedCard>
  );
};
